import React, { useEffect } from "react";
import { Page, Text, Banner } from "@shopify/polaris";
import { openBeacon, setBeaconStore } from "../../utils/BeaconUtils";

export default function AccessDeniedPage({ storeUrl = "" }) {
  useEffect(() => {
    if (storeUrl) {
      setBeaconStore(storeUrl);
    }
  }, [storeUrl]);

  return (
    <Page title="Access requires a paid Shopify plan">
      <Banner
        title={"Access requires a paid Shopify plan"}
        tone="warning"
        action={{ content: "Request access", onAction: openBeacon }}
      >
        <Text variant="bodyMd" as="p">
            We do not permit development stores access by default. If you need
            access for testing or evaluation, please request access and let us know why you need it.
        </Text>
      </Banner>
    </Page>
  );
}


